export default __webpack_public_path__ + "static/media/06.b8c6ece1.jpg";